import React, { useState } from 'react';
import styled from 'styled-components/macro';
import Popup from 'components/Popup';

const ImagePopup = ({ image, size = 'medium_large', ...props }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpen = () => setIsOpen(true);
    const handleClose = () => setIsOpen(false);

    return (
        <>
            <ThumbnailImage {...props} src={image?.sizes?.[size]} onClick={handleOpen} alt="" />
            
            <Popup isOpen={isOpen} onClose={handleClose}>
                <Container>
                    <FullImage src={image?.url} alt="" />
                </Container>
            </Popup>
        </>
    );
};


export default ImagePopup;


const ThumbnailImage = styled.img`
    cursor: pointer;
`;

const Container = styled.div`
    width: 100%;
    height: 100%;
    padding: 3rem;
    background-color: ${props => props.theme.app_background};
`;

const FullImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
